import type {} from "@lit/react";
import { GridColumnGroup as GridColumnGroupElement, } from "@vaadin/grid/vaadin-grid-column-group.js";
import * as React from "react";
import { createComponent, type WebComponentProps } from "../utils/createComponent.js";
export { GridColumnGroupElement, };
export type GridColumnGroupEventMap = Readonly<{}>;
const events = {} as GridColumnGroupEventMap;
export type GridColumnGroupProps = WebComponentProps<GridColumnGroupElement, GridColumnGroupEventMap>;
export const GridColumnGroup = createComponent({
    elementClass: GridColumnGroupElement, events, react: React, tagName: "vaadin-grid-column-group"
});
